import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_DISTRIBUTORS, GET_DISTRIBUTORS_FOR_USER, UPDATE_USER_DISTRIBUTORS, GET_ADMINISTRATORS, UPDATE_ADMINISTRATORS } from "../constants/action-types";


const API_CONFIG = getApiConfig();

/* 
    Get all Distributors if admin, otherwise get all Distributors for current user
*/
export const getDistributors = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/distributors`, {
        method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_DISTRIBUTORS,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/* 
    Get all Distributors for User
*/
export const getDistributionsForUser = (userId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/distributors?userId=${userId}`, {
        method: "get",
    })
        .then(res => {
            dispatch({
                type: GET_DISTRIBUTORS_FOR_USER,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/* 
    Update which Distributors a Users can admin
*/
export const updateUserDistributors = (distributorList, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/updateUserDistributors`, {
        method: "post",
        data: distributorList
    })
        .then(res => {
            dispatch({
                type: UPDATE_USER_DISTRIBUTORS,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
}

/*
    Get Administrators of a Distributor
*/
export const getAdministrators = (distributorId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/administrators/${distributorId}`, {
        method: "get"
    }).then(res => {
        dispatch({
            type: GET_ADMINISTRATORS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/*
    Update which Users have admin for a Distributor
*/
export const updateAdministrators = (administrators, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/updateTargetingAdministrators`, {
        method: "post",
        data: administrators
    }).then(res => {
        dispatch({
            type: UPDATE_ADMINISTRATORS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
}